import { render, staticRenderFns } from "./TitledSwitchField.vue?vue&type=template&id=0c4386ee&scoped=true&"
import script from "./TitledSwitchField.vue?vue&type=script&lang=js&"
export * from "./TitledSwitchField.vue?vue&type=script&lang=js&"
import style0 from "./TitledSwitchField.vue?vue&type=style&index=0&id=0c4386ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4386ee",
  null
  
)

export default component.exports